interface NavigationDescriptor
{
	typ: string;
 	style?: string;
	brand?: HTMLElement;
}

interface NavigationItemDescriptor
{
	id?: string;
	value: string;
	href: string;
	active?: boolean;
}

class Navigation
{
	private element: HTMLElement;

	constructor(descriptor: NavigationDescriptor)
	{
		this.element = document.createElement( 'ul' );
		const tempA = document.createElement( 'a');
		$( this.element ).addClass( 'nav' );

		if ( descriptor.typ )
		{
			$( this.element ).addClass( 'nav-'  + descriptor.typ);
		}

		if ( descriptor.style )
		{
			$( this.element ).addClass( 'nav-'  + descriptor.style );
		}

		if ( descriptor.brand )
		{
			$( tempA ).addClass( 'navbar-brand' );
			$( tempA ).append( descriptor.brand );
			$( this.element ).append( tempA );
		}

	}

	public addItem( descriptor: NavigationItemDescriptor ) : void
	{
		const tempLI = document.createElement( 'li');
		const tempA = document.createElement( 'a');

		$(tempLI).attr( 'role', 'presentation' );

		$(tempA).html( descriptor.value );
		$(tempA).attr( 'href', descriptor.href );

		if ( descriptor.id )
		{
			$( tempLI ).attr( 'id', descriptor.id );
		}

		if ( descriptor.active )
		{
			$(tempA).addClass( 'avtive' );
		}

		$( tempLI ).append( tempA );
		$( this.element ).append( tempLI );
	}

	public getElement() : HTMLElement
	{
		return this.element;
	}

}
